/**
 * Compute the Hamming distance between two bit strings.
 * @see {@link https://en.wikipedia.org/wiki/Hamming_distance}
 * @param descriptor1 - First bit string.
 * @param descriptor2 - Second bit string.
 * @returns The Hamming distance.
 */
export function getHammingDistance(descriptor1, descriptor2) {
    let sum = 0;
    for (let i = 0; i < descriptor1.length; i++) {
        sum += descriptor1[i] ^ descriptor2[i];
    }
    return sum;
}
//# sourceMappingURL=getHammingDistance.js.map